import styled from '@emotion/styled'
import { Colors } from '@/constants/styles/color'

const StyledDialogHeader = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0px 16px;
  color: ${Colors.BLACK};
`

const StyledArrowBackIcon = styled.div`
  width: 24px;
  height: 24px;
  img {
    width: 24px;
    height: 24px;
  }
`

const StyledDialogHeaderText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
`

const StyledCloseIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 24px;
    height: 24px;
  }
`

const StyledDialogBody = styled.div`
  height: calc(100% - 47px);
  overflow-y: scroll;
  overflow-x: hidden;
  color: ${Colors.BLACK};
`

const StyledCvsResultContainer = styled.div`
  padding: 0 24px;
`

const StyledCvsResultMessage = styled.div`
  text-align: center;
  color: ${Colors.BLACK};
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
  margin: 40px 0 10px 0;
`

const StyledCvsResultNotes = styled.div`
  color: ${Colors.DARK_RED};
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  font-weight: 500;
  margin: 12px 0 16px 0;
`

const StyledCvsResultTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  tr {
    border: 1px solid ${Colors.DARK_GRAY};
    height: 40px;
  }
  th {
    color: ${Colors.WHITE};
    background: ${Colors.PRIMARY_GRAY};
    font-size: 11px;
    font-weight: 500;
    line-height: 11px;
    width: 80px;
    padding: 0 12px;
    text-align: left;
  }
  td {
    color: ${Colors.PRIMARY_GRAY};
    font-size: 13px;
    font-weight: 500;
    line-height: 13px;
    padding: 0 12px;
    word-break: break-word;
  }
  td.number {
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
  }
  a {
    color: ${Colors.ORANGE};
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
  }
`

export {
  StyledDialogHeader,
  StyledArrowBackIcon,
  StyledDialogHeaderText,
  StyledCloseIcon,
  StyledDialogBody,
  StyledCvsResultContainer,
  StyledCvsResultMessage,
  StyledCvsResultNotes,
  StyledCvsResultTable,
}
